import type { ColumnDef } from '@tanstack/react-table';
import type { Residente } from '@condo/contracts';
import { Badge } from '@/components/ui/badge';
import { DataTable } from '@/components/common/data-table';

const columns: ColumnDef<Residente>[] = [
  {
    accessorKey: 'nombre',
    header: 'Nombre',
    cell: ({ row }) => {
      const r = row.original;
      return (
        <div className="min-w-0">
          <p className="font-display text-sm font-semibold text-[var(--color-ink)]">
            {r.nombre} {r.apellidos}
          </p>
          <p className="text-[0.6875rem] text-[var(--color-ink-muted)] font-mono">
            {r.rut}
          </p>
        </div>
      );
    },
  },
  {
    accessorKey: 'email',
    header: 'Correo',
    cell: ({ row }) => (
      <span className="text-xs text-[var(--color-ink-soft)]">{row.original.email}</span>
    ),
  },
  {
    accessorKey: 'telefono',
    header: 'Telefono',
    cell: ({ row }) => (
      <span className="text-xs font-mono text-[var(--color-ink-soft)]">
        {row.original.telefono ?? '—'}
      </span>
    ),
  },
  {
    accessorKey: 'activo',
    header: 'Estado',
    cell: ({ row }) => (
      <Badge variant={row.original.activo ? 'success' : 'neutral'}>
        {row.original.activo ? 'Activo' : 'Inactivo'}
      </Badge>
    ),
  },
];

interface Props {
  data: Residente[];
  isLoading?: boolean;
  onRowClick?: (r: Residente) => void;
}

export function ResidentesTable({ data, isLoading, onRowClick }: Props) {
  return (
    <DataTable
      columns={columns}
      data={data}
      isLoading={isLoading}
      onRowClick={onRowClick}
    />
  );
}
